import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { EntityReferenceBasic, TagLabel } from '@/shared/types';

import type { GlossaryCategoryItem } from '@/entities/glossary';

type CreateGlossaryCategoryRequest = {
  name: string;
  displayName?: string;
  description?: string;
  tags?: TagLabel[];
  owners?: EntityReferenceBasic[];
  reviewers?: EntityReferenceBasic[];
  domains?: string[];
};

export const createGlossaryCategoryApi = async (
  request: CreateGlossaryCategoryRequest
): Promise<GlossaryCategoryItem> => {
  const { data } = await openMetadataApiClient.put<GlossaryCategoryItem>('/glossaries', request);
  return data;
};

export type { CreateGlossaryCategoryRequest };
